"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertReduxFilterModelToGraphQL = void 0;
const presentation_aware_table_filter_utils_1 = require("../../../../client/product/hooks/presentation-aware-table-filter.utils");
const reviewed_status_filter_utils_1 = require("../../../../client/product/hooks/reviewed-status-filter.utils");
const utils_1 = require("../../../../client/product/hooks/utils");
/**
  * Converts Redux filter state to GraphQL compatible filter object.
  * - Table filtering logic
  * - Search by input text
  * - Filter by selected value from the middle section
  * - Filter by reviewed status for a specific attribute (isReviewed)
  */
const convertReduxFilterModelToGraphQL = ({ tableFilter, selectedAttributeNode, search, reviewStatus, }) => {
    // Strip the reviewed filter before passing to the standard filter builder — it lives at
    // the top-level ProductPresentationFilter, not inside ProductFilter.
    const { filteredTableFilter, reviewedFilterItem, lastReviewedByFilterItem, } = (0, reviewed_status_filter_utils_1.stripReviewAttributeFilters)(tableFilter);
    const tableProductFilter = (0, presentation_aware_table_filter_utils_1.generatePresentationAwareProductFilter)(filteredTableFilter);
    const selectedAttributeFilter = selectedAttributeNode ? (0, utils_1.createPresentationFilterFromAttributeNode)(selectedAttributeNode) : null;
    const baseFilter = (0, utils_1.mergePresentationAwareProductFilter)((0, utils_1.mergePresentationAwareFilters)(tableProductFilter, selectedAttributeFilter), search);
    const isReviewed = (0, reviewed_status_filter_utils_1.buildIsReviewedFilter)(reviewedFilterItem, reviewStatus);
    const lastReviewedBy = (0, reviewed_status_filter_utils_1.buildLastReviewedByFilter)(lastReviewedByFilterItem, reviewStatus);
    if (!isReviewed && !lastReviewedBy) {
        return baseFilter;
    }
    return Object.assign(Object.assign(Object.assign({}, baseFilter !== null && baseFilter !== void 0 ? baseFilter : {}), lastReviewedBy && {
        product: Object.assign(Object.assign({}, baseFilter === null || baseFilter === void 0 ? void 0 : baseFilter.product), { lastReviewedBy }),
    }), isReviewed && { isReviewed });
};
exports.convertReduxFilterModelToGraphQL = convertReduxFilterModelToGraphQL;
